import styled from "@emotion/styled";

export const Container = styled("div")`
  display: flex;
  margin-top: 25px;
`;

export const ChatButton = styled("button")`
  all: unset;
  cursor: pointer;
  margin-left: 12px;

  svg {
    width: 44px;
    height: 44px;
  }
`;
